import {
  FieldValues,
  useForm as useOriginalForm,
  UseFormProps,
  UseFormReturn,
} from 'react-hook-form';
import { useEffect } from 'react';
import {
  registerFormInstance,
  unregisterFormInstance,
} from '@utils/Form/form-monitor';

export function useForm<TFieldValues extends FieldValues = FieldValues>(
  props?: UseFormProps<TFieldValues>
): UseFormReturn<TFieldValues> {
  const methods = useOriginalForm<TFieldValues>(props);

  useEffect(() => {
    const instance = {
      isDirty: () => methods.formState.isDirty,
    };
    registerFormInstance(instance);

    return () => {
      unregisterFormInstance();
    };
  }, [methods]);

  return methods;
}
